module.exports = __webpack_public_path__ + "static/russel-fb0959c9615807b4b5c56a1452279e80.png";